import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { routes } from '../../routing/routes';
import { canLoadAppOnRestorableRoute } from '../restore';
import { PERSIST_ON_PATHS } from '../snc/useSncPersistLocation';
import { useNavigate } from './navigate';

// List of whitelisted initial routes
const validInitialRoutes = [
  ...PERSIST_ON_PATHS,
  routes.root,
  routes.auth,
  routes.esignStart,
  routes.esignSuccess,
  routes.esignRefused,
];

export const useValidInitialRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isFirstNavigation, setIsFirstNavigation] = useState(true);

  useEffect(() => {
    if (!isFirstNavigation) return;

    setIsFirstNavigation(false);

    if (canLoadAppOnRestorableRoute()) return;

    const isValidInitialRoute = validInitialRoutes.some((route) => {
      if (route === routes.root) return false;
      return location.pathname.startsWith(route);
    });

    if (!isValidInitialRoute) navigate.root();
  }, [isFirstNavigation, location.pathname, navigate]);

  return !isFirstNavigation;
};
